<template>
  <v-row v-if="team.bio">
    <v-col cols="12" md="2"><strong>Bio:</strong></v-col>
    <v-col cols="12" md="10" v-html="team.bio"></v-col>
  </v-row>
  <v-row v-if="team.website">
    <v-col cols="12" md="2"><strong>Website:</strong></v-col>
    <v-col cols="12" md="10">
      <a :href="`{{ team.website }}`">{{ team.website }}</a>
    </v-col>
  </v-row>
  <v-row v-if="team.facebook">
    <v-col cols="12" md="2"><strong>Facebook:</strong></v-col>
    <v-col cols="12" md="10">
      <a :href="`https://www.facebook.com/${team.facebook}`">{{ team.facebook }}</a>
    </v-col>
  </v-row>
  <v-row v-if="team.twitter">
    <v-col cols="12" md="2"><strong>X:</strong></v-col>
    <v-col cols="12" md="10">
      <a :href="`https://www.x.com/${team.twitter}`">{{ team.twitter }}</a>
    </v-col>
  </v-row>
  <v-row v-if="team.instagram">
    <v-col cols="12" md="2"><strong>Instagram</strong></v-col>
    <v-col cols="12" md="10">
      <a :href="`https://www.instagram.com/${team.instagram}`">{{ team.instagram }}</a>
    </v-col>
  </v-row>
  <v-row v-if="team.youtube">
    <v-col cols="12" md="2"><strong>YouTube</strong></v-col>
    <v-col cols="12" md="10">
      <a :href="`https://www.youtube.com/@${team.youtube}`">{{ team.youtube }}</a>
    </v-col>
  </v-row>
  <v-row v-if="team.vimeo">
    <v-col cols="12" md="2"><strong>Vimeo</strong></v-col>
    <v-col cols="12" md="1-">
      <a :href="`https://www.vimeo.com/${team.vimeo}`">{{ team.vimeo }}</a>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { ITeamDTO, TeamDisplayDTO, TeamDTO } from '@/dtos';
import { computed } from 'vue';
interface Props {
  team: ITeamDTO | TeamDisplayDTO;
}
const props = defineProps<Props>();

const team = computed(() => {
  return props.team ?? new TeamDTO();
});
</script>
